import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  transactions: null,
  recentTransactions: null,
  isFirstLoad: true,
  totalCount: null,
  eppOptions: null,
  eppOptionsLoading: false,
  eppOptionsError: null,
};

const transactionsSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {
    transactionRequest(
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
        limit?: number;
        cycleStartDate?: string;
        customerTypeId?: string;
        fromDate?: string;
        toDate?: string;
        merchantCategory?: string;
        allTransactions?: boolean;
        offset?: number;
        isRefresh?: boolean;
      }>
    ) {
      state.loading = true;
      state.transactions = null;
      state.totalCount = null;
      state.error = null;
      state.isFirstLoad = true;
    },
    transactionFetched(state, action) {
      state.loading = false;
      state.transactions = action.payload?.activitySummary?.activities;
      state.error = null;
      state.isFirstLoad = false;
      state.totalCount = action.payload?.activitySummary?.totalCount;
    },
    recenttransactionFetched(state, action) {
      state.loading = false;
      state.recentTransactions =
        action.payload?.activitySummary?.activities?.slice(0, 3);
      state.error = null;
    },
    transactionFetchFailed(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.isFirstLoad = false;
    },
    resetTransactionsSlice(state) {
      return initialState; // Reset the slice to its initial state
    },
    // New reducers for EPP options
    eppOptionsRequest(
      state,
      action: PayloadAction<{
        accountId: string;
        customerId: string;
        activityId: string;
      }>
    ) {
      state.eppOptionsLoading = true;
      state.eppOptionsError = null;
      state.eppOptions = null;
    },
    eppOptionsFetched(state, action) {
      state.eppOptionsLoading = false;
      state.eppOptions = action.payload?.installmentPlanOptions || [];
      state.eppOptionsError = null;
    },
    eppOptionsFetchFailed(state, action) {
      state.eppOptionsLoading = false;
      state.eppOptionsError = action.payload;
      state.eppOptions = null;
    },
    clearEppOptions(state) {
      state.eppOptions = null;
      state.eppOptionsLoading = false;
      state.eppOptionsError = null;
    },
  },
});

export const {
  transactionRequest,
  transactionFetched,
  recenttransactionFetched,
  transactionFetchFailed,
  resetTransactionsSlice,
  eppOptionsRequest,
  eppOptionsFetched,
  eppOptionsFetchFailed,
  clearEppOptions,
} = transactionsSlice.actions;

export default transactionsSlice.reducer;
